<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.countries.states.form.state_code')"
            :is-required="true"
            :hint="__('settings.countries.states.form.state_code_hint')"
        >
            <DInput
                id="state_code"
                v-model="form.state_code"
                :placeholder="__('settings.countries.states.form.state_code')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('state_code')"
                :invalid-feedback="errors.state_code"
                maxlength="3"
                :disabled="isStateCodeDisabled() || onlyShowForm"
            />
        </DFormRow>
        <DFormRow
            v-for="language in languages"
            :key="language"
            :label="__(`settings.countries.states.form.name_${language}`)"
            :is-required="true"
            :hint="__('settings.countries.states.form.name_hint')"
        >
            <DInput
                :id="`name_${language}`"
                v-model="form[`name_${language}`]"
                :placeholder="__(`settings.countries.states.form.name_${language}`)"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid(`name_${language}`)"
                :invalid-feedback="errors[`name_${language}`]"
                maxlength="128"
                :disabled="onlyShowForm"
            />
        </DFormRow>

        <DFormControls
            v-if="!onlyShowForm"
            :cancel-route="$route('settings.countries.states.index', { country: country.country_code })"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    submitUrl: {
        type: String,
        default: ''
    },
    country: {
        type: Object,
        default: () => ({})
    },
    state: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    onlyShowForm: {
        type: Boolean,
        default: false,
    }
})

const languages = [
    'de',
    'en',
    'da',
    'nl',
    'fi',
    'fr',
    'it',
    'no',
    'pr',
    'es',
    'sv',
    'sk',
    'cz',
    'rs',
]
const nameFields = {}

languages.forEach((language) => {
    nameFields[`name_${language}`] = ref(props.state[`name_${language}`] ?? null)
})

const form = useForm({
    state_code: ref(props.state?.state_code ?? null),
    ...nameFields,
})

const isStateCodeDisabled = () => {
    return !!props.state?.state_code
}

const emit = defineEmits(['form-submitted'])

const submitForm = () => {
    emit('form-submitted', form)
}
</script>
